
export default class Cglobal 
{
    static contentScrollToTheTop=null;
}
